<script setup lang="ts">
// Product of Launch Maniac LLC, Las Vegas, Nevada - (725) 444-8200 support@launchmaniac.com

import { RouterView, useRoute } from 'vue-router';
import { computed } from 'vue';
import Sidebar from './components/Sidebar.vue';
import TopBar from './components/TopBar.vue';
import { useAuthStore } from './stores/auth';

const route = useRoute();
const authStore = useAuthStore();

const publicRoutes = ['login', 'setup'];
const showAppShell = computed(() => {
  return authStore.isAuthenticated && !publicRoutes.includes(route.name as string);
});
</script>

<template>
  <div v-if="showAppShell" class="flex h-screen bg-gray-50">
    <Sidebar />
    <div class="flex-1 flex flex-col overflow-hidden">
      <TopBar />
      <main class="flex-1 overflow-y-auto p-6">
        <RouterView />
      </main>
    </div>
  </div>
  <RouterView v-else />
</template>
